// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__Gh8oi","header":"styles_header__GSPZj"};